import http from 'axios';
import get from 'lodash/get';

import { getCurrentSession } from '../helpers/auth';
import { toastr } from '../components/CustomToast';

const CLIENT_ID = process.env.REACT_APP_MANAGEMENT_APP_CLIENT_ID;
const WEB_API_URL = process.env.REACT_APP_MANAGEMENT_WEB_API_URL;

export const errorResponseToastr = (err) => {
  toastr.error({
    title: 'Error',
    message: get(err, 'response.data.detail', 'An Error Occured'),
  });
};

export default class ManagementAPIClient {
  constructor() {
    this.axios = http.create({
      baseURL: WEB_API_URL,
      timeout: 20000,
      headers: { 'Content-Type': 'application/json' },
    });

    this.axios.interceptors.request.use(async function (config) {
      const { accessToken } = await getCurrentSession(CLIENT_ID, 'management');
      if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`;
      }
      return config;
    });
  }

  async GET(endpoint = '', params = {}) {
    const response = await this.axios.get(endpoint, { params });
    const data = response?.data;
    // Handle both array responses and {result, value} envelope
    if (Array.isArray(data)) return data;
    if (data?.result === 'success') return data.value;
    return data;
  }
}